<template>
  <div class="hello">
    <div class="hye1">核心价值</div>
    <div class="hye3">
      <div style="margin: 10px">
        <img
          style="width: 384px; height: 120px"
          src="../assets/official/Group 47983@2x.png"
          alt=""
        />
      </div>
      <div style="margin: 10px">
        <img
          style="width: 384px; height: 120px"
          src="../assets/official/Group 47986@2x.png"
          alt=""
        />
      </div>
      <div style="margin: 10px">
        <img
          style="width: 384px; height: 120px"
          src="../assets/official/Group 47987@2x.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'knowledge',
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.hello {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1440px;
  height: 380px;
  background: #fff;
}
.hye1 {
  height: 56px;
  font-size: 40px;
  font-weight: 500;
  color: #121221;
  line-height: 56px;
  margin: 80px 0 24px;
}
.hye2 {
  height: 18px;
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 18px;
  margin: 0 0 60px;
}
.hye3 {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
}
</style>
